import { FunctionalComponent, h } from 'preact';
import SideNav, { ButtonsConfig } from '../../../components/side-nav/side-nav';
import MerchantLogo from '../../../components/merchant-logo/merchant-logo';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	merchantLogoUrl: string;
	buttonsConfig: ButtonsConfig | null;
	hidePoweredByLogo?: boolean;
}

const SharedLocationSideNav: FunctionalComponent<Props> = ({
	isOpen,
	onClose,
	merchantLogoUrl,
	buttonsConfig,
	hidePoweredByLogo = false
}) => {
	return buttonsConfig ? (
		<SideNav
			hidePoweredByLogo={hidePoweredByLogo}
			header={
				<MerchantLogo className="shared-location-side-nav-merchant-log" merchantLogoUrl={merchantLogoUrl} />
			}
			isOpen={isOpen}
			buttonsConfig={buttonsConfig}
			onClose={onClose}
		/>
	) : null;
};

export default SharedLocationSideNav;
